import { css as styledCss } from "styled-components";
import { BREAKPOINTS } from "../constants/sideNav";

export const smallScreenMediaQuery = `@media screen and (max-width: ${BREAKPOINTS.SMALL_SCREEN}px)`;

/**
 * Viewport media query plus a JS compact-shell flag.
 * Ask TeamForm sits beside the page, so window width alone is too late —
 * the app raises SideNav's breakpoint by the chat pane width.
 */
export const applySmallScreenObject = (props, styles) => {
  // Ask TeamForm stays a right-hand column, so its handle must not flip
  // to the top-edge / row-resize layout used by the SideNav bottom bar.
  if (props.$compactLayout === false) {
    return {};
  }
  return {
    [smallScreenMediaQuery]: styles,
    ...(props.$isSmallScreen ? styles : {}),
  };
};

export const applySmallScreenCss = (props, chunk) => styledCss`
  ${smallScreenMediaQuery} {
    ${chunk}
  }
  ${props.isSmallScreen ? chunk : ""}
`;
